<style scoped="scoped">
@import 'mobilehome.css';
</style>
<style  scoped="scoped">
@import '../../../assets/css/common.css';
</style>
<style>
  .phonehome #banner .banner-item img{
    width: 100vw;
  }
  .phonehome #banner .banner_content .el-carousel__indicator .el-carousel__button{
    width:12px;
    height:12px;
    background:rgba(255,255,255,1);
    border-radius:50%;
    opacity: 1;
  }
  .phonehome #banner .banner_content .el-carousel__indicator.is-active .el-carousel__button{
    width:46px;
    height:12px;
    background:rgba(255,255,255,1);
    border-radius:6px;
  }
  .phonehome .swiper-p1 .swiper-pagination-bullet-active {
    opacity: 1;
    background: white;
    /* background: url(../../assets/images/banner_fyq_active.gif) center center no-repeat !important; */
  }
  .phonehome .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    content: '';
  }
  .phonehome .el-form-item__label{
    font-size: 12px;
    white-space: pre;
  }
  .phonehome .el-input__inner{
    height: 24px;
    line-height: 24px;
  }
  .phonehome .el-form-item__error{
    top: 73%;
  }
  .phonehome .swiper-p2 .swiper-pagination-bullet{
    background-color: white;
    border:1px solid #688AE2;
  }
  .phonehome .swiper-p2 .swiper-pagination-bullet.swiper-pagination-bullet-active{
    background: #688AE2;
  }
  .phonehome .errmsg.el-message{
    width: 80vw !important;
    min-width: 80vw !important;
  }
  .phonehome .el-textarea .el-textarea__inner{
    box-shadow:0px 0px 0px rgba(0,0,0,0);
    outline: none;
    -webkit-appearance: none;/*清除移动端textarea上边框阴影*/
  }
  /* .el-main{
    height:calc(100vh -  140px)!important;
    overflow: hidden!important;
  } */
</style>
<template>
  <div class="phonehome">
    <header class="mobilehead">
      <div class="header_con clearfix">
        <div class="mobilelogo icon-my-logo fl" @click="clickLogin">
        </div>
        <div class="menubtn fr" @click="showlogin">
          <img src="../../../assets/images/icon/mobilemenu.png" v-if="!menulist"/>
          <img src="../../../assets/images/icon/mobileclose.png" v-if="menulist"/>
        </div>
        <!-- <div class="menubtn fr" @click="showmenu">
          <img src="../../../assets/images/icon/mobilelogin.png" v-if="!islogin"/>
          <img src="../../../assets/images/icon/mobilelogout.png" v-if="islogin"/>
        </div> -->
      </div>
    </header>
    <div class="menulist" v-show="menulist" @touchmove.prevent>
      <el-menu
        router
        :default-active="pagedefault"
        text-color="#D3D3D5"
        active-text-color="#108EE9">
        <el-menu-item index="/" @click="clickLogin">首页</el-menu-item>
        <!-- <el-menu-item index="/front/Mobilehome/mobiledevdoc/introduce">开发文档</el-menu-item> -->
        <!-- <el-menu-item index="/front/Mobilehome/mobileEgcode">示例代码</el-menu-item> -->
        <el-menu-item index="/front/Mobilehome/business/mobilecooperation">商务合作</el-menu-item>
    </el-menu>
    </div>
    <div v-show="menulist" @click="menulist = !menulist;" class="menulist-mask" @touchmove.prevent></div>
    <div class="menulist" v-show="loginlist" @touchmove.prevent>
      <div class="listitem" v-if="!islogin" @click="loginFront">登录</div>
      <div class="listitem" v-if="!islogin" @click="register">注册</div>
      <div class="listitem" v-if="islogin" @click="personalInfo">开发者</div>
      <div class="listitem" v-if="islogin" @click="exitFront">退出</div>
    </div>
    <div v-show="loginlist" @click="loginlist = !loginlist" class="loginlist-mask" @touchmove.prevent></div>
    <div class="banner" id="banner">
      <div class="banner_content">
        <div class="swiper-container hidden-xs swiper-container1">
              <div class="swiper-wrapper">
                  <div class="swiper-slide lwc-imghandle">
                    <div class="banner-item banner-img1">
                          <img src="../../../assets/images/front/mobilebanner.png" alt="">
                    </div>
                  </div>
                  <div class="swiper-slide lwc-imghandle">
                    <div class="banner-item banner-img2">
                          <img src="../../../assets/images/front/mobilebanner2.png" alt="">
                        </div>
                  </div>
                  <div class="swiper-slide lwc-imghandle">
                    <div class="banner-item banner-img3">
                          <img src="../../../assets/images/front/mobilebanner3.png" alt="">
                        </div>
                  </div>
              </div>
              <div class="swiper-pagination swiper-p1"></div>
          </div>
      </div>
    </div>
    <section class="product" style="background:white;">
      <div class="product_title">
        <img src="../../../assets/images/front/mobiletitle.png" style="display:block; width:52.4%;"/>
      </div>
      <div class="title_underline">
        九科星<span style="font-size: 14px">教育资源</span>开放<span style="font-size: 14px">平台是什么？</span>
      </div>
      <div class="product_intr">
        九科星资源开放平台，<br/>
        是指将九科星优质的K12教育资源，开放给广大开发者，<br/>
        开发者使用所需的教学资源，<br/>
        以便完善自己的教育产品或项目建设，<br/>
        从而实现共赢。
      </div>
      <div class="product_con">
        <img src="../../../assets/images/front/mobileicon.png" />
      </div>
    </section>
    <section class="ppjs">
      <div class="title_en">BRAND&nbsp;CORNERSTONE</div>
      <div class="ppjs_title">品牌基石</div>
      <div class="title_bottom">
        <img src="../../../assets/images/front/title_bottom.png" />
      </div>
      <div class="ppjs_con clearfix">
        <div class="clickbox fl lc">
          <img src="../../../assets/images/front/mobilesquare-01.png" />
          <div class="clicktitle">专业研发流程</div>
          <div class="clickcontent" style="top:44%">精心独创“643”<br />即6审4校3通编辑模式</div>
        </div>
        <div class="clickbox fl td ml8">
          <img src="../../../assets/images/front/mobilesquare-02.png" />
          <div class="clicktitle">专业研发团队</div>
          <div class="clickcontent" style="top:33%">
            VIP&nbsp;&nbsp;800人<br />
            Ⅰ级&nbsp;&nbsp;2000人<br />
            常规作者&nbsp;&nbsp;5000人<br />
            专职研发人员&nbsp;&nbsp;1000人<br />
            专职研究员&nbsp;&nbsp;600人
          </div>
        </div>
        <div class="clickbox fl dz mt18">
          <img src="../../../assets/images/front/mobilesquare-04.png" />
          <div class="clicktitle gxdz">个性化定制</div>
          <div class="clickcontent" style="top:48%">
            如单独命卷和专项产品等
          </div>
        </div>
        <div class="clickbox fl jg ml8 mt18">
          <img src="../../../assets/images/front/mobilesquare-03.png" />
          <div class="clicktitle">专业研发机构</div>
          <div class="clickcontent" style="top:27%">
            教学备考研究中心<br />
            测试评价研究中心<br />
            传媒文化研究中心<br />
            考试命题研究中心<br />
            义务教育研究中心<br />
            期刊产品研究中心<br />
            江苏产品部
          </div>
        </div>
      </div>
    </section>
    <section class="djfs">
      <div class="title_en">DOCKING&nbsp;MODE</div>
      <div class="djfs_title">对接方式（请用PC打开）</div>
      <div class="title_bottom">
        <img src="../../../assets/images/front/title_bottom.png" />
      </div>
      <div class="djfs_box">
        <div class="djfs_con">
          <div>
            <div class="con_item">
              <div class="con_item_title">一、直接调用资源开放平台的API接口</div>
              <div class="clearfix con_item_wrap">
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilestep1.png" style="width:88%" />
                  <div>注册成为开发者</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilestep2.png" style="width:90%"/>
                  <div>获取资源使用权限</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilestep3.png" style="width:90%"/>
                  <div>调用所需API</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilestep4.png" style="width:100%"/>
                  <div>使用教学资源</div>
                </div>
              </div>
              <div class="con_item_title">二、将题库组件、资源库组件集成到开发者产品中</div>
              <div class="clearfix con_item_wrap">
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilegreen1.png" style="width:88%"/>
                  <div>注册成为开发者</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilegreen2.png" style="width:90%"/>
                  <div>获取资源使用权限</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilegreen3.png" style="width:92%"/>
                  <div>嵌入所需组件</div>
                </div>
                <div class="fl con_item_con">
                  <img src="../../../assets/images/front/mobilegreen4.png" style="width:100%"/>
                  <div>使用资源和系统功能</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ptys">
      <div class="title_en">RESOURCE&nbsp;INTRODUCTION</div>
      <div class="ptys_title">资源介绍</div>
      <div class="title_bottom">
        <img src="../../../assets/images/front/title_bottom.png" />
      </div>
      <div class="swiper-container hidden-xs swiper-container2">
        <div class="swiper-wrapper">
            <div class="swiper-slide lwc-imghandle">
              <div class="clickbox lc">
                <div class="boxF">
                  <div class="boxS">
                    <div class="boxT">
                      <div class="overlay">
                        <i class="iconfont iconshitiku"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info">
                  <h1>九科星试题库</h1>
                  <div class="info-explain">试题总量超<span v-if="questionNum">{{questionNum}}</span><span v-else>720</span>万道、覆盖知识点38000余个。试题质量严格把关，正确率高达98%以上。涵盖各地区、年级学科知识点。</div>
                </div>
              </div>
            </div>
            <div class="swiper-slide lwc-imghandle">
              <div class="clickbox lc">
                <div class="boxF">
                  <div class="boxS">
                    <div class="boxT">
                      <div class="overlay">
                        <i class="iconfont iconziyuanzhongxin"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info">
                  <h1>资源中心</h1>
                  <div class="info-explain">各类资源总量高达<span v-if="docNum">{{docNum}}</span><span v-else>300</span>万份，多年积累，数万教师精心整理上传，包括同步课件，教案，导学案，备课素材，音视频资料等。</div>
                </div>
              </div>
            </div>
            <div class="swiper-slide lwc-imghandle">
              <div class="clickbox lc">
                <div class="boxF">
                  <div class="boxS">
                    <div class="boxT">
                      <div class="overlay">
                        <i class="iconfont iconpaper"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info">
                  <h1>历年试卷</h1>
                  <div class="info-explain">试卷来源丰富，涵盖历年中高考、模拟考、期中期末考、月考、单元考。几乎覆盖全国各地区、各年级学科、教材版本。</div>
                </div>
              </div>
            </div>
        </div>
        <div class="swiper-pagination swiper-p2"></div>
      </div>
    </section>
    <section class="swhz">
      <div class="swhz_box">
        <div class="title_en">BUSINESS COOPERATION</div>
        <div class="swhz_title">商务合作</div>
        <div class="title_bottom">
          <img src="../../../assets/images/front/title_bottom.png" />
        </div>
        <div class="swhz_con">
          <div class="con_left">
            <div class="left_title">联系我们</div>
            <div class="left_content">
              <div class="clearfix">
                <div class="con_icon phone fl">
                  <img src="../../../assets/images/front/phone_icon.png" style="margin-top:6px;" />
                </div>
                <div class="fl icon_word">商务合作 ：17719991109（宋老师）</div>
              </div>
              <div class="clearfix">
                <div class="con_icon QQ fl">
                  <img src="../../../assets/images/front/qq_icon.png" />
                </div>
                <div class="fl">QQ：3588036337</div>
              </div>
              <div class="clearfix">
                <div class="con_icon QQ fl">
                  <img src="../../../assets/images/front/qq_icon.png" />
                </div>
                <div class="fl">QQ：2351918274</div>
              </div>
              <div class="clearfix">
                <div class="con_icon local fl">
                  <img src="../../../assets/images/front/local_icon.png" style="margin-top: 6px;" />
                </div>
                <div class="fl icon_word">公司地址：江西省南昌市昌北经济开发区菊圃路1818号太阳城</div>
              </div>
            </div>
          </div>
          <div class="con_right" >
            <div class="right_title">在线申请</div>
            <div class="right_content">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" label-position="left" >
                <el-form-item label="    单位名称:" prop="companyName">
                  <div class="label_img">
                    <img src="../../../assets/images/front/company_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.companyName" :maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="    联 系 人:" prop="contactsName" >
                  <div class="label_img">
                    <img src="../../../assets/images/front/person_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.contactsName" :maxlength="32"></el-input>
                </el-form-item>
                <el-form-item label="    联系电话:" prop="contactsPhone" >
                  <div class="label_img">
                    <img src="../../../assets/images/front/phone_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.contactsPhone" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="     留      言:" prop="message" >
                  <div class="label_img">
                    <img src="../../../assets/images/front/message_icon.png" />
                  </div>
                  <el-input type="textarea" v-model="ruleForm.message" :maxlength="200" style="margin-top:8px;"></el-input>
                  <div class="remind">（商务经理将在1-3个工作日内联系您）</div>
                </el-form-item>
                <el-form-item>
                  <div class='subbtnbox'>
                    <el-button type="primary" @click="submitForm()" class="subbtn" v-loading="loading">提交</el-button>
                  </div>

                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div id="toTop" class="toTop" v-show="isShow" @click="toTop()">
    </div>
    <!-- <footer>
      <div class="footer_con">
        <div class="footer_con_two">Copyright ©1996-2019 All Rights Reserved<br/>三端科技&nbsp;版权所有</div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import commonService from '@/service/commonService'
import {mapGetters, mapMutations} from 'vuex'
export default {
  name: 'Mobilehome',
  data () {
    return {
      loading: false,
      bannerHeight: 496,
      islogin: false,
	  	ruleForm: {
        companyName: '',
        contactsName: '',
        contactsPhone: '',
        message: ''
      },
      labelPosition: 'left',
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        message: [
          { required: false, message: '请填写留言', trigger: 'blur' }
        ]
      },
      activeName: '1',
      describe_show: true,
      isShow: false,
      menulist: false,
      loginlist: false,
      pagedefault: '/',
      docNum: '',
      questionNum: ''
    }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  watch: {
    userinfo (newVal, oldVal) {
      this.islogin = !!(this.userinfo && this.userinfo.clientId)
    }
  },
  mounted () {
    // this.getDocumentNum()
    this.getQuestionNum()
    window.addEventListener('scroll', this.handleScroll)
    this.islogin = !!(this.userinfo && this.userinfo.clientId)
    var swiper = new Swiper('.swiper-container1', {
      pagination: '.swiper-p1',
      autoplay: 5000,
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 0,
      loop: true
    })
    var swiper1 = new Swiper('.swiper-container2', {
      pagination: '.swiper-p2',
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 0,
      loop: false
    })
    if (this.$route.meta && this.$route.meta.index) {
      // 实现路由切换
      this.pagedefault = this.$route.meta.index
      if (this.$route.fullPath === '/front/Mobilehome/mobiledevdoc/agreement') {
        this.$router.push({name: 'mobileAgreement'})
        return
      }
      this.$router.push({path: this.$route.meta.index})
      return
    }
    this.$router.push({name: 'Mobilehome'})
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 跳转新页面
    clickLogin () {
      if (this.$route.name === 'Mobilehome') {
        return;
      }
      this.pagedefault = ''
      this.$router.push({name: 'Mobilehome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
      this.menulist = false
    },
    loginFront () {
      this.pagedefault = '/'
      this.$router.push({name: 'mobileLogin'})
      this.$nextTick(() => {
        this.pagedefault = '/front/Mobilehome/developer/detail'
      })
    },
    register () {
      this.$router.push({name: 'mobileRegister'})
    },
    exitFront () {
      this.$cookie.delete('token')
      // 清空Vuex
      this.clearUserInfo()
      this.$router.push({name: 'mobileLogin'})
      this.pagedefault = '/'
      this.$nextTick(() => {
        this.pagedefault = '/front/Mobilehome/developer/detail'
      })
    },
    personalInfo () {
      // this.pagedefault = '/'
      this.$router.push({name: 'mobiledetail'})
      // this.$nextTick(() => {
      //   this.pagedefault = '/front/Mobilehome/developer/detail'
      // })
    },
    // openNewWin (url) {
    //   if (url) { window.open(url, '_blank') } else {
    //     this.goToPAD()
    //   }
    // },
    // },
    // 屏幕滚动
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let i = 0
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    },
    submitForm () {
      this.loading = true
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          try {
            let data = await commonService.contractUs(this.ruleForm)
            this.loading = false
            this.$message({
              message: '申请成功,我们会稍后和您联系!',
              type: 'success',
              customClass: 'errmsg'
            })
            this.$refs['ruleForm'].resetFields()
          } catch (e) {
            this.$message.error({
              message: e && e.msg,
              customClass: 'errmsg'
            })
            this.loading = false
          }
        } else {
          this.loading = false
          this.$message.error({
            message: '请完善您的信息',
            customClass: 'errmsg'
          })
	      }
      })
    },
    showlogin () {
      // this.loginlist = false
      this.menulist = !this.menulist
      if (this.loginlist) {
        this.loginlist = !this.loginlist
      }
    },
    showmenu () {
      // this.menulist = false
      this.loginlist = !this.loginlist
      if (this.menulist) {
        this.menulist = !this.menulist
      }
    },
    ...mapMutations({
      clearUserInfo: 'clearUserInfo'
    }),
    async getDocumentNum () {
      let data = await commonService.getDocumentNum()
      this.docNum = data.data.allDocumentNumbers && data.data.allDocumentNumbers.slice(0, -4)
    },
    async getQuestionNum () {
      let data = await commonService.getQuestionNum()
      this.questionNum = data.data.allDocumentNumbers && data.data.allDocumentNumbers.slice(0, -4)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobileHome/index.vue